export default __webpack_public_path__ + "static/media/reg1.81f8878b.png";